"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MLO_LEAD_GLOBAL_EXCLUDED_STATES = exports.MloLicenseStatus = void 0;
const homeState_1 = require("./origination/homeState");
/**
 * License status for a mortgage loan originator. Values are lowercase — matches DB column.
 * @TranslateToPython
 */
var MloLicenseStatus;
(function (MloLicenseStatus) {
    MloLicenseStatus["PENDING"] = "pending";
    MloLicenseStatus["ACTIVE"] = "active";
    MloLicenseStatus["INACTIVE"] = "inactive";
    MloLicenseStatus["EXPIRED"] = "expired";
})(MloLicenseStatus || (exports.MloLicenseStatus = MloLicenseStatus = {}));
/**
 * States no MLO may work a lead in, whatever licenses they hold. Mirrored into Python so bulk lead
 * loads drop these rows before upload, not only at claim/send time in MloLicenseLeadFilterService.
 * @TranslateToPython
 */
exports.MLO_LEAD_GLOBAL_EXCLUDED_STATES = [
    homeState_1.StateTwoLetterCodes.texas,
    homeState_1.StateTwoLetterCodes.southCarolina,
    homeState_1.StateTwoLetterCodes.wyoming,
    homeState_1.StateTwoLetterCodes.wisconsin,
    homeState_1.StateTwoLetterCodes.nebraska,
    homeState_1.StateTwoLetterCodes.idaho,
];
